module.exports = __webpack_public_path__ + "img/water-arrow-up.3fb0249b.svg";